<template>
  <div v-loading="loading" class="t-table" :class="{'w-table_moving': dragState.dragging}">
    <el-table v-if="data&&data.length>0" :data="data"
              ref="elTable"
              :border="border"
              :stripe="stripe"
              :height="height"
              :max-height="maxHeight"
              :style="{ width: width }"
              size="small"
              :element-loading-text="text"
              @row-click="rowClick"
              @select="selectRow"
              @select-all="selectAll"
              @selection-change="selectionChange"
    >
      <slot name="before"></slot>
      <template  v-for="(col, index) in tableHeader">
        <el-table-column v-if="col.renderDraw"
                         :prop="col.prop"
                         :label="col.label"
                         :width="col.width"
                         show-overflow-tooltip
                         :align="col.align"
                         :min-width="col.minWidth"
                         :header-align="col.headerAlign"
                         :column-key="index.toString()"
        >
          <template #default="scope" >
            <div v-html="col.renderDraw(scope.row)"></div>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" width="50" min-width="50" v-else-if="col.type=='index'">
          <template #default="scope" >
            {{scope.$index+indexStart}}
          </template>
        </el-table-column>
        <el-table-column type="selection" :selectable="col.selectable" :reserve-selection="col.reserveSelection" width="50" minWidth="50" v-else-if="col.type=='selection'"></el-table-column>
        <el-table-column :label="col.label" :width="col.width" :minWidth="col.minWidth" v-else-if="col.type=='user'">
          <template #default="scope" >
            <user-box :detail="scope.row"></user-box>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :minWidth="col.minWidth" v-else-if="col.type=='shop'">
          <template #default="scope" >
            <shop-box :detail="scope.row"></shop-box>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :minWidth="col.minWidth" v-else-if="col.type=='repairGoods'">
          <template #default="scope" >
            <div class="goods-box" v-for="item in scope.row[col.prop]">
              <img :src="filePath+item.picture"/>
              <div class="goods-content">
                <div class="text ellipsis_line2">
                  {{item.name}}&nbsp
                </div>
                <div class="id">
                  编号:{{item.code}}&nbsp;&nbsp;{{item.property}}
                </div>
              </div>
            </div>
            <div class="shop-box">
              <user-avatar :width="18" :height="18" :font-size="12" :img="scope.row.logo" :text="scope.row.shopName"></user-avatar>
              <span class="ml5">{{scope.row.shopName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :minWidth="col.minWidth" v-else-if="col.type=='goodsList'">
          <template #default="scope" >
            <div class="goods-box" v-for="item in scope.row[col.prop]">
              <img :src="filePath+item.picture"/>
              <div class="goods-content">
                <div class="text ellipsis_line2">
                  {{item.name}}&nbsp;&nbsp;x {{item.reCount || item.count}}
                </div>
                <div class="id">
                  编号:{{item.code}}&nbsp;&nbsp;{{item.property}}
                </div>
              </div>
              <div v-if="col.status==null || col.status==true" class="goods-tag" :class="`goods-type-${item.goodsType}`">{{['售','租','洗'][item.goodsType]}}</div>
            </div>
              <div class="shop-box" v-if="col.status==null || col.status==true">
                  <user-avatar :width="18" :height="18" :font-size="12" :img="scope.row.logo" :text="scope.row.shopName"></user-avatar>
                  <span class="ml5">{{scope.row.shopName}}</span>
              </div>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :minWidth="col.minWidth" v-else-if="col.type=='refund'">
          <template #default="scope" >
            <refund-box :detail="scope.row"></refund-box>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :minWidth="col.minWidth" v-else-if="col.type=='delivery'">
          <template #default="scope" >
            <delivery-box :detail="scope.row"></delivery-box>
          </template>
        </el-table-column>

        <el-table-column :label="col.label" :width="col.width" :minWidth="col.minWidth" v-else-if="col.type=='goods'">
          <template #default="scope" >
            <goods-box :detail="scope.row"></goods-box>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :minWidth="col.minWidth" v-else-if="col.type=='goodShop'">
          <template #default="scope" >
            <goods-shop-box :detail="scope.row"></goods-shop-box>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :minWidth="col.minWidth" v-else-if="col.type=='feedback'">
          <template #default="scope">
            <div v-html="scope.row.content"></div>
            <image-show v-if="scope.row.picList&&scope.row.picList.length>0" :width="50" :height="50" :images="scope.row.picList.map(item=>filePath+item.url)"></image-show>
          </template>
        </el-table-column>

        <el-table-column :label="col.label" :width="col.width" :min-width="col.minWidth" v-else-if="col.type=='image'">
          <template #default="scope" >
            <div
              class="b-img-c"
              :class="{'img-radio':col.radio}"
              :style="{
               width:`${col.imgWidth || 50}px`,
               height:`${col.imgHeight || 50}px`
              }">
              <image-show :width="col.imgWidth" :height="col.imgHeight"
                :images="[`${scope.row[col.prop].startsWith('http')?scope.row[col.prop]:filePath+scope.row[col.prop]}`]"></image-show>
            </div>

          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :min-width="col.minWidth" v-else-if="col.type=='video'">
          <template #default="scope" >
            <video  preload="none" :style="{width:col.width-20+'px'}">
              <source :src="filePath+scope.row[col.prop]" />
            </video>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :min-width="col.minWidth" v-else-if="col.type=='bank'">
          <template #default="scope" >
            <bank-box :detail="scope.row"></bank-box>
          </template>
        </el-table-column>
        <el-table-column :label="col.label" :width="col.width" :min-width="col.minWidth" v-else-if="col.type=='orderInfo'">
          <template #default="scope" >
            <order-box :detail="scope.row"></order-box>
          </template>
        </el-table-column>
        <el-table-column v-else=""
                         :prop="col.prop"
                         :label="col.label"
                         :width="col.width"
                         :show-overflow-tooltip="col.tooltip"
                         :min-width="col.minWidth"
                         :type="col.type"
                         :align="col.align"
                         :fixed="col.fixed"
                         :header-align="col.headerAlign"
                         :column-key="index.toString()"
        ></el-table-column>
      </template>
      <slot name="ext"></slot>
      <!--min-width="300"-->
      <el-table-column v-if="$slots.default" label="操作" class-name	="column-opt" fixed="right" :width="opWidth?opWidth:optWidth"	>
        <template  v-slot="scope">
          <div :ref="'opt'+scope.$index"  >
            <slot name="default" :row="scope.row" :$index="scope.$index"></slot>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <empty-data-image v-else=""></empty-data-image>
  </div>
</template>

<script>
import EmptyDataImage from './layout/empty-data-image'
import ImageShow from "../base/image-show";
import UserAvatar from "@/components/base/user-avatar.vue";
import UserBox from "@view/components/user-box.vue";
import ShopBox from "@view/components/shop/shop-box.vue";
import GoodsBox from "@view/components/goods/goods-box.vue";
import GoodsShopBox from "@view/components/goods/goods-shop-box.vue";
import DeliveryBox from "@view/components/order/delivery-box.vue";
import RefundBox from "@view/components/order/refund-box.vue";
import BankBox from "@view/components/bank-box.vue";
import OrderBox from "@view/components/order/order-box.vue";
export default {
  components: {
    OrderBox,
    BankBox,
    RefundBox, DeliveryBox, GoodsShopBox, GoodsBox, ShopBox, UserBox, UserAvatar, ImageShow, EmptyDataImage},
  props: {
    data: {
      default: function () {
        return []
      },
      type: Array
    },
    header: {
      default: function () {
        return []
      },
      type: Array
    },
    width:{
      type:String,
      default:"100%"
    },
    border:{
      type:Boolean,
      default:false,
    },
    stripe:{
      type:Boolean,
      default:true,
    },
    text:{
      type:String,
      default:"拼命加载中"
    },
    height:{
      type:Number | String,
      /*default:"68vh",*/
    },
    maxHeight:{
      type:Number,
    },
    opWidth:{
      type:Number,
    }
  },
  name: 't-table',
  data () {
    return {
      tableHeader: this.header,
      dragState: {
        start: -1, // 起始元素的 index
        end: -1, // 结束元素的 index
        move: -1, // 移动鼠标时所覆盖的元素 index
        dragging: false, // 是否正在拖动
        direction: undefined // 拖动方向
      },
      optWidth:100,
      indexStart:1,
    }
  },
  computed: {
    loading: function () {
      return this.$store.state.loading
    },
  },
  watch: {
    header (val, oldVal) {
      this.tableHeader = val
    },
    //数据变化
    data(val){
      //操作栏宽度自适应
      this.initOptWidth();
      //自动获取索引值
      this.initIndex();
    }
  },
  mixins: [tableBase],
  methods: {
    selectAll(selection){
      this.$emit('select-all',selection);
    },
    selectRow(selection, row){
      this.$emit('select',selection,row);
    },
    selectionChange(val){
      this.$emit('selection-change',val);
    },

    toggleRowSelection(row){
      this.$refs['elTable']&&this.$refs['elTable'].toggleRowSelection(row);
    },
    clearSelection(){
      this.$refs['elTable']&&this.$refs['elTable'].clearSelection();
    },
    rowClick(row, column, event){
      this.$emit('row-click',row,column,event);
    },
    initOptWidth(){
      this.$nextTick(()=>{
        setTimeout(()=>{
          if(this.$refs){
            let count = 0;
            for(var name in this.$refs){
              if(name.startsWith("opt")&&this.$refs[name]&&count<this.$refs[name].childElementCount){
                count = this.$refs[name].childElementCount
              }
            }
            this.optWidth = count*50;
          }else{
            this.optWidth = 100;
          }
        },200)
      })
    },
    initIndex(){
      let page = this.$store.state.vm.currentPage;
      let size = this.$store.state.vm.pageSize;
      if(size&&page){
        if(page==1){
          this.indexStart = 1;
        }else{
          this.indexStart = (page-1) * size +1
        }
      }
    }
  },
  mounted () {
    this.initOptWidth();
  },
}
</script>

<style lang="less">
.t-table {
  border-radius: 10px;
  overflow: hidden;
}

.el-table thead{
  color: #000000 !important;
  font-weight: bold;
  text-align: left;
}
.el-table .cell{
  line-height: 40px!important;
}
.img-radio{
  border-radius: 50%;
}
.b-img-c{
  img{
    width: 100%;
    height: 100%;
  }
}

.goods-box{
  display: flex;
  position: relative;
  .goods-tag{
    position: absolute;
    left: 0;
    top: 0;
    padding: 5px;

    color: #ffffff;
    font-size: 10px;
    line-height: 10px;
    &.goods-type-0{
      background: @primary;
    }
    &.goods-type-1{
      background: @warning;
    }
    &.goods-type-2{
      background: @dink;
    }
  }
  &+.goods-box{
    margin-top: 10px;
  }
  img{
    width: 60px;
    height: 60px;
    margin-bottom: 5px;
  }
  .goods-content{
    flex: 1;
    margin-left: 10px;
    .id{
      display: flex;
      align-items: center;
      color: #9e9e9e;
      height: 20px;
    }
    .text{
      font-weight: bold;
      line-height: 18px;
    }
  }
}
.shop-box{
  padding: 4px 0;
  border-top: 1px solid #f0f0f0;
  line-height: 20px;
  color:@primary;
  display: flex;
  align-items: center;
}
</style>
